class WIupsellPro extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        sessionStorage.removeItem('upsellData');
        sessionStorage.removeItem('product-upsell-info');
        sessionStorage.removeItem('ogProductForm');
        this.popInnerHtml();
        this.upsellATCbutton();
        this.upsellATC();
        this.afterAddTocart();
        this.closingPop();        
    }
    // creating pro upsell pop inner html
    popInnerHtml() {
        document.addEventListener("upsellproinfo", ()=>{
            let proInfo = JSON.parse(sessionStorage.getItem('product-upsell-info'));
            let plusSvg = ' <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewbox="0 0 64 64"><path d="M32 9v46m23-23H9" class="cls-1"></path></svg>';
            let upsellListProduct = "";
            proInfo.forEach((pro,index) => {
                if (index == 0 ) {
                    this.querySelector('.WI_upsell_product_img img').src = pro.img;
                    this.querySelector('.WI_upsell_product_txt h2').innerHTML = pro.title;
                    // this.querySelector('.WI_upsell_product_txt p').innerHTML = pro.price;
                    this.style.display = 'flex';
                }
                if (index !== 0) {
                    upsellListProduct += `<div class="WI_upsellProduct">`;
                    upsellListProduct += `<div class="WI_upsellProduct_img">`;
                    upsellListProduct += `<img src="${pro.image}" alt="upsell product">`;
                    upsellListProduct += `</div>`;
                    upsellListProduct += `<div class="WI_upsellProduct_txt">`;
                    upsellListProduct +=  `<h2>`;
                    upsellListProduct += `${pro.title}`;
                    upsellListProduct += `</h2>`;
                    // upsellListProduct +=  `<p>`;
                    // upsellListProduct += `${pro.price}`;
                    // upsellListProduct += `</p>`;
                    upsellListProduct += `</div>`;
                    upsellListProduct += `<div class="WI_upsellProduct_form">`;
                    upsellListProduct +=  `<button type="button" data-id="${pro.variant}" data-add="noAdded">`;
                    upsellListProduct +=   plusSvg+" ADD";
                    upsellListProduct +=   `</button>`;
                    upsellListProduct += `</div>`;
                    upsellListProduct += `</div>`;
                }
            });
            this.querySelector('.WI_upsell_product_upsell_list_con').innerHTML = upsellListProduct;
            this.addButton();
        });
    }

    // Clicking on upsell product add button
    addButton() {
            let addBtn = this.querySelectorAll('.WI_upsellProduct_form button');
            let formData = [];
            addBtn.forEach(btn => {
                btn.addEventListener("click", ()=>{
                    let variantId = Number(btn.dataset.id);
                    if (btn.dataset.add == "noAdded") {
                        btn.dataset.add = "Added";
                        btn.style.backgroundColor = "#ba4444";
                        btn.innerHTML = "REMOVE";
                        let obj = {
                            "id": variantId,
                            "quantity": 1 
                        }
                        formData.push(obj);
                        sessionStorage.setItem('upsellData', JSON.stringify(formData));
                    }else if(btn.dataset.add == "Added"){
                        btn.dataset.add = "noAdded";
                        btn.style.backgroundColor = "#000";
                        btn.innerHTML = "ADD";
                        formData.forEach((data,index) => {
                            console.log(data);
                            if (data.id == variantId) {
                                formData.splice(index,1);
                                sessionStorage.setItem('upsellData', JSON.stringify(formData));
                            }
                        });
                    }
                    
                })
            });
    }

    // Upsell add to cart function
    upsellATC() {
        let atcButton = this.querySelector('.WI_upsell_product_atc button');
        atcButton.addEventListener('click', async ()=>{
            this.querySelector('.WI_upsell_product_atc_txt').style.display = "none";
        this.querySelector('.WI_upsell_product_atc_loading').style.display = "flex";
            let formData = {
                'items': JSON.parse(sessionStorage.getItem('upsellData'))
            };
            if (sessionStorage.getItem('upsellData') !== "") {
                try {
                    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(formData)
                    });
                    document.dispatchEvent(new CustomEvent('upsellogproductadded', {bubbles: true}));
                } catch (error) {
                    console.error('Error:', error);
                }
            }else{
                document.dispatchEvent(new CustomEvent('upsellogproductadded', {bubbles: true}));
            }

        });
    }

    // When you press upsell ATC button
    upsellATCbutton() {
        document.addEventListener('upsellogproductadded', async ()=>{
            let ogformData = sessionStorage.getItem('ogProductForm');
            console.log(JSON.stringify(ogformData));
            
            try {
                
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: ogformData,
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                      'X-Requested-With': 'XMLHttpRequest'
                    }
                });
                this.querySelector('.WI_upsell_product_atc_txt').style.display = "block";
                this.querySelector('.WI_upsell_product_atc_loading').style.display = "none";
                document.dispatchEvent(new CustomEvent('wirefreshcart',{bubbles: true}));
              } catch (error) {
                console.error('Error:', error);
              }
        })
    }

    // When add to cart is performed
	afterAddTocart() {
		document.addEventListener('wirefreshcart', () => {
			this.style.display = 'none';
		})
	}

    // Closing upsell pop
    closingPop() {
        this.querySelector('.WI_upsell_cls button').addEventListener('click', ()=>{
            this.style.display = 'none';
        })
    }

}

customElements.define('wi-upsellpop', WIupsellPro);

class WIupsellProBtn extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.clickOn()    
    }

    // Click on button
    clickOn() {
        let upsellBtn = this.querySelector('button');
        let proImg;
        let proTitle;
        let proPrice;
        let sessionFormData;
        let formDataObj;
        
        upsellBtn.addEventListener('click', () => {
            let textInputArray = [];
            let radioInputArray = [];
            let textInputLen;
            let radioInputLen;
            formDataObj = document.querySelector(".product-single__meta").querySelector('form');
            console.log(formDataObj);
            
            // Get the value of the 'data-exOptions' attribute from the upsell button
            let exOptionsDataset = upsellBtn.getAttribute('data-exOptions');
            console.log(exOptionsDataset);
            proTitle = upsellBtn.getAttribute('data-proTitle');
            proImg = upsellBtn.getAttribute('data-proImage');
            // Check if the 'data-exOptions' value is 'true'
            if (exOptionsDataset == 'true') {
                // Check if the 'personalizeTrue' session storage item is set to 'true'
                if (sessionStorage.getItem('personalizeTrue') == 'true') {
                    // Get all required input fields within the extra options section
                    let extraOptionsInputs = document.querySelector(".product-single__meta").querySelector('.WI_extoption_all');
                    let textInputcon = extraOptionsInputs.querySelectorAll('.itHasTextInput');
                    let radioInputcon = extraOptionsInputs.querySelectorAll('.itHasRadioInput');

                    for (let i = 0; i < textInputcon.length; i++) {
                        textInputLen = i+1;
                        let textInput = textInputcon[i].querySelector('input[required]');
                        if (textInput.value.trim() === "") {
                            textInput.style.border = "1px solid red";
                            textInput.parentElement.querySelector('p').style.display = "block";
                        }else{
                            textInput.style.border = "1px solid black";
                            textInput.parentElement.querySelector('p').style.display = "none";
                            textInputArray.push("true");
                        }
                    }

                    for (let j = 0; j < radioInputcon.length; j++) {
                        radioInputLen = j+1;
                        let radioInput = radioInputcon[j].querySelectorAll('input[required]');
                        for (let k = 0; k < radioInput.length; k++) {
                            let inp = radioInput[k];
                            if (inp.checked) {
                                inp.parentElement.querySelector('p').style.display = "none";
                                radioInputArray.push("true");
                                break;
                            }else{
                                inp.parentElement.querySelector('p').style.display = "block";
                            }
                        }
                    }
                        setTimeout(() => {
                            if (textInputLen == textInputArray.length && radioInputLen == radioInputArray.length) {
                                makingFormData(formDataObj);  
                            }            
                        }, 10);
                } else {
                    // Trigger the 'inputIsValid' custom event if 'personalizeTrue' is not set
                    makingFormData(formDataObj);    
                }
            } else {
                // Trigger the 'inputIsValid' custom event if 'data-exOptions' is not set to 'true'
                makingFormData(formDataObj);
            }
        });
        

            function makingFormData(proForm) {
                sessionFormData = theme.utils.serialize(proForm);
                console.log(sessionFormData);
                setTimeout(() => {
                    document.dispatchEvent(new CustomEvent('inputIsValid', { bubbles: true }));
                }, 100);
                //  // Convert FormData to a plain object
                //  formDataObj = {};
                // for (let [key, value] of sessionFormData.entries()) {
                //     formDataObj[key] = value;
                // }
            };
                document.addEventListener('inputIsValid', ()=>{
                    sessionStorage.setItem('ogProductForm', sessionFormData);
                    let proArray = [];
                    let proObj = {
                        "img": proImg,
                        "title": proTitle
                    }
                    proArray.push(proObj);
                    let metaInfo = this.querySelectorAll('.WI_upsellProductMeta');
                    metaInfo.forEach(meta => {
                        let metaImage = meta.getAttribute('data-meta-image');
                        let metaTitle = meta.getAttribute('data-meta-title');
                        let metaPrice = meta.getAttribute('data-meta-price');
                        let metaVariant = meta.getAttribute('data-meta-variant');
                        let proMeta = {
                            "image": metaImage,
                            "title": metaTitle,
                            "price": metaPrice,
                            "variant": metaVariant
        
                        };
                        proArray.push(proMeta);
                    });
                        console.log(proArray);
                        sessionStorage.setItem('product-upsell-info', JSON.stringify(proArray));
                        document.dispatchEvent(new CustomEvent('upsellproinfo', {bubbles: true}));
                })
    }

}

customElements.define('wi-upsellpopbtn', WIupsellProBtn);